import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Card, Tabs, Tab,
} from 'react-bootstrap';
import Error from '../../Components/Error';
import DriverManagementSection from './Components/DriverManagementSection';
import FleetManagementSection from './Components/FleetManagementSection';

function OperatorPortal() {
  const { operatorId } = useParams();
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('drivers');

  if (!operatorId) {
    return (
      <div className="container mt-5">
        <Error error="Missing operator ID" setError={setError} />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h1>Operator Portal</h1>
      <p className="text-muted">Manage your drivers and vehicles</p>

      {error && <Error error={error} setError={setError} />}

      <Card>
        <Card.Body>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
          >
            <Tab eventKey="drivers" title="Drivers">
              <DriverManagementSection
                operatorId={operatorId}
                setError={setError}
              />
            </Tab>
            <Tab eventKey="vehicles" title="Vehicles">
              <FleetManagementSection
                operatorId={operatorId}
                setError={setError}
              />
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </div>
  );
}

export default OperatorPortal;
